import React, { Dispatch, SetStateAction } from 'react';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { X } from 'lucide-react';
import { JobPostingPreview } from '../../Preview';
import UnifiedActions from './UnifiedActions';
import { JobPostingTabData } from '../../../../../../../utils/types/JobOpenings';

interface PreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  jobPostingData: JobPostingTabData;
  resolvedPostId?: string;
  liveHtml: string;
  isSaving: boolean;
  onSaveOrCreate: () => void;
  setJobPostId: Dispatch<SetStateAction<string>>;
  setStages: (value: any) => void;
}

export const PreviewModal: React.FC<PreviewModalProps> = ({
  isOpen,
  onClose,
  jobPostingData,
  resolvedPostId,
  liveHtml,
  isSaving,
  onSaveOrCreate,
  setJobPostId,
  setStages,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth='lg'
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          maxHeight: '90vh',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        },
      }}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          px: 3,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Typography variant='h6' sx={{ fontWeight: 700, color: 'text.primary' }}>
          Public Job Post Preview
        </Typography>
        <IconButton
          aria-label='close'
          onClick={onClose}
          sx={{
            color: 'text.secondary',
            '&:hover': { bgcolor: 'action.hover', color: 'text.primary' },
          }}
          size='small'
        >
          <X size={20} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 0, bgcolor: 'background.default', overflowY: 'auto' }}>
        <Box sx={{ p: 3 }}>
          <JobPostingPreview
            jobPostingData={jobPostingData}
            jobPostId={resolvedPostId ?? ''}
            setJobPostId={setJobPostId}
            setStages={setStages}
            liveHtml={liveHtml}
            hidePublishBanner={true}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2, px: 3, borderTop: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }}>
        <Box sx={{ width: '100%' }}>
          <UnifiedActions
            resolvedPostId={resolvedPostId}
            isSaving={isSaving}
            jobPostingData={jobPostingData}
            onSaveOrCreate={onSaveOrCreate}
          />
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default PreviewModal;
